<template>
    <div v-if="additionals">
        <div v-if="additionals.salaVacinacaoLogada && !!additionals.salaVacinacaoLogada.id">
            <rkm-data-table
                :fields="fields"
                :repository="repositories.distribuicao"
                ref="RkmDataTable"
            >
                <template v-slot:cell(actions)="row">
                    <rkm-button
                        @click="$refs.ModalEstorno.open(row.item)"
                        authorize="destroy-imunizacao-distribuicao"
                        color="danger"
                        small
                        title="Estornar"
                    >
                        <rkm-icon icon="undo-alt" />
                    </rkm-button>

                    <rkm-button
                        title="Imprimir"
                        color="secondary"
                        @click="handlePrint(row.item.saidaId)"
                        small
                    >
                        <rkm-icon icon="print" />
                    </rkm-button>
                </template>
            </rkm-data-table>

            <ModalEstorno
                @save="$refs.RkmDataTable.refresh()"
                ref="ModalEstorno"
            />
        </div>

        <rkm-alert v-else color="warning">
            A unidade logada não é uma sala de vacinação ou está desativada, favor cadastra-la para efetuar uma distribuição.
        </rkm-alert>
    </div>
</template>

<script>
// Components.
import ModalEstorno from './components/estorno/Modal'

// Mixins.
import { error, permissao, repository } from '@/mixins'

// Vuex.
import { mapActions } from 'vuex'

export default {
    components: { ModalEstorno },
    computed: {
        fields() {
            const fields = [
                { key: 'unidadeNomeDe', label: 'Unidade distribuidora', name: 'cadastroUnidadeDe.nomeFantasia', searchable: true, sortable: true },
                { key: 'infraestruturaNomeDe', label: 'Local distribuidor', name: 'cadastroInfraestruturaDe.nome', searchable: true, sortable: true },
                { key: 'unidadeNomePara', label: 'Unidade recebedora', name: 'cadastroUnidadePara.nomeFantasia', searchable: true, sortable: true },
                { key: 'infraestruturaNomePara', label: 'Local recebedor', name: 'cadastroInfraestruturaPara.nome', searchable: true, sortable: true },
                { key: 'data', label: 'Data', name: 'imunizacaoSaida.dataSaida', searchable: true, sortable: true },
            ]

            if (this.verificarPermissao('create-imunizacao-entrada')) {
                fields.push({ class: 'col-min text-center', key: 'actions', label: 'Ações' })
            }

            return fields
        },
    },
    created() {
        this.repositories = {
            distribuicao: this.getConectaSusRepository('imunizacao.distribuicao'),
            impressao: this.getConectaSusRepository('impressao.imunizacao')
        }
    },
    data: () => ({
        additionals: null,
    }),
    methods: {
        ...mapActions(['setLoading', 'unsetLoading']),
        load() {
            this.setLoading()

            this.repositories.distribuicao.index()
                .then(response => {
                    this.additionals = Object.assign(response.data.additionals)
                    this.$emit('loaded', this.additionals)
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        handlePrint(id) {
            this.setLoading()
            this.repositories.impressao.distribuicao(id)
                .then(response => {
                    const content = new Blob([response.data], {type: response.headers['content-type']})
                    const url = URL.createObjectURL(content)
                    const link = document.createElement('a')

                    link.href = url
                    link.target = '_blank'
                    link.click()
                    link.remove()
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        }
    },
    mixins: [ error, permissao, repository ],
    mounted() {
        this.load()
    },
}
</script>